document.addEventListener('DOMContentLoaded', function () {
  var siteHeader = document.getElementById('SiteHeader');
  if (siteHeader) {
    var setHeaderHeight = function () {
      document.documentElement.style.setProperty('--header-h', siteHeader.offsetHeight + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
  }

  var toggle = document.getElementById('NavToggle');
  var nav = document.getElementById('SiteNav');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('.main-product__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.getAttribute('data-full');
    });
  });

  var modal = document.getElementById('pedido-modal');
  if (modal) {
    var whatsappNumber = modal.getAttribute('data-whatsapp');
    var titleEl = document.getElementById('pedido-modal-title');
    var priceEl = document.getElementById('pedido-modal-price');
    var imgEl = document.getElementById('pedido-modal-img');
    var qtyField = document.getElementById('pedido-modal-qty-field');
    var qtyInput = document.getElementById('pedido-modal-qty');
    var packsEl = document.getElementById('pedido-modal-packs');
    var form = document.getElementById('pedido-modal-form');
    var lastFocused = null;

    function buildPacks(trigger) {
      var packs = [];
      for (var i = 1; i <= 2; i++) {
        var texto = trigger.getAttribute('data-pack' + i + '-texto');
        var precio = trigger.getAttribute('data-pack' + i + '-precio');
        if (texto) packs.push({ texto: texto, precio: precio || '' });
      }
      return packs;
    }

    function openModal(trigger) {
      titleEl.textContent = trigger.getAttribute('data-nombre') || '';

      var imagen = trigger.getAttribute('data-imagen') || '';
      if (imagen) {
        imgEl.src = imagen;
        imgEl.alt = trigger.getAttribute('data-nombre') || '';
        imgEl.hidden = false;
      } else {
        imgEl.hidden = true;
      }

      var packs = buildPacks(trigger);
      packsEl.innerHTML = '';

      if (packs.length) {
        priceEl.hidden = true;
        qtyField.hidden = true;
        packsEl.hidden = false;

        packs.forEach(function (pack, index) {
          var option = document.createElement('label');
          option.className = 'pedido-modal__pack-option';
          option.innerHTML =
            '<input type="radio" name="pack" value="' + pack.texto.replace(/"/g, '&quot;') + ' - ' + pack.precio.replace(/"/g, '&quot;') + '"' + (index === 0 ? ' checked' : '') + '>' +
            '<span class="pedido-modal__pack-texto">' + pack.texto + '</span>' +
            '<span class="pedido-modal__pack-precio">' + pack.precio + '</span>';
          packsEl.appendChild(option);
        });
      } else {
        packsEl.hidden = true;
        var precio = trigger.getAttribute('data-precio') || '';
        priceEl.textContent = precio;
        priceEl.hidden = !precio;
        qtyField.hidden = false;
        qtyInput.value = 1;
      }

      form.reset();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pedido-modal-open');
      lastFocused = trigger;
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pedido-modal-open');
      if (lastFocused) lastFocused.focus();
    }

    document.querySelectorAll('[data-pedido-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(trigger);
      });
    });

    modal.querySelectorAll('[data-pedido-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    modal.querySelector('[data-pedido-qty-minus]').addEventListener('click', function () {
      var current = parseInt(qtyInput.value, 10) || 1;
      if (current > 1) qtyInput.value = current - 1;
    });
    modal.querySelector('[data-pedido-qty-plus]').addEventListener('click', function () {
      var current = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = current + 1;
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;

      var pedidoLinea;
      if (!packsEl.hidden) {
        var checked = packsEl.querySelector('input[name="pack"]:checked');
        if (!checked) return;
        pedidoLinea = 'Pedido: ' + checked.value;
      } else {
        pedidoLinea = 'Cantidad: ' + qtyInput.value + (priceEl.textContent ? ' — Precio: ' + priceEl.textContent : '');
      }

      var data = new FormData(form);
      var lines = [
        'Hola! Quiero hacer un pedido:',
        '',
        'Producto: ' + titleEl.textContent,
        pedidoLinea,
        '',
        'Datos de entrega:',
        'Nombre: ' + data.get('nombre'),
        'Celular: ' + data.get('celular'),
        'Ciudad: ' + data.get('ciudad')
      ].filter(Boolean);

      var mensaje = encodeURIComponent(lines.join('\n'));

      function irAWhatsapp() {
        window.open('https://wa.me/' + whatsappNumber + '?text=' + mensaje, '_blank', 'noopener');
        closeModal();
      }

      if (typeof fbq === 'function') {
        fbq('track', 'Contact');
        fbq('track', 'InitiateCheckout');
        setTimeout(irAWhatsapp, 250);
      } else {
        irAWhatsapp();
      }
    });
  }
});
